/**
 * @generated SignedSource<<a4becf6527068dcd0582e0e649d5bbf8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type taskApprover_softwareReleasesApprovers_jiraVersionApprover$data = {
  readonly user: {
    readonly extendedProfile?: {
      readonly jobTitle: string | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly picture: AGG$URL;
  };
  readonly " $fragmentSpreads": FragmentRefs<"approvalDrawer_softwareReleasesApprovers_jiraVersionApprover" | "approvalStatus_softwareReleasesApprovers">;
  readonly " $fragmentType": "taskApprover_softwareReleasesApprovers_jiraVersionApprover";
};
export type taskApprover_softwareReleasesApprovers_jiraVersionApprover$key = {
  readonly " $data"?: taskApprover_softwareReleasesApprovers_jiraVersionApprover$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskApprover_softwareReleasesApprovers_jiraVersionApprover">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "taskApprover_softwareReleasesApprovers_jiraVersionApprover",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "user.name"
          },
          {
            "kind": "ScalarField",
            "name": "picture"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jobTitle"
                  }
                ]
              }
            ],
            "type": "AtlassianAccountUser"
          }
        ]
      },
      "action": "THROW",
      "path": "user"
    },
    {
      "kind": "FragmentSpread",
      "name": "approvalDrawer_softwareReleasesApprovers_jiraVersionApprover"
    },
    {
      "kind": "FragmentSpread",
      "name": "approvalStatus_softwareReleasesApprovers"
    }
  ],
  "type": "JiraVersionApprover"
};

(node as any).hash = "2f386310c911f628d06832824656bc52";

export default node;
